import React from "react";
import TrustedByForm from "./TrustedByForm";

const EditTrustedBy = () => {
  return (
    <>
      <TrustedByForm action="Edit" />
    </>
  );
};

export default EditTrustedBy;


